export default __webpack_public_path__ + "static/media/Legguards of the Defiant.b6bbddb1.jpg";